import { SHOW_PRIMARY_MENU, SHOW_SECONDARY_SIDEBAR } from "constants/searchParms.id";
import { stringToBoolean } from "utils/typeConverter";

export const getRawShowPrimarySideBarFromSearchParams = (searchParams: any) => {
    return searchParams.showPrimaryMenu;
};

export const getRawShowSecondarySideBarFromSearchParams = (searchParams: any) => {
    return searchParams.showSecondarySideBar;
};

export const getShowPrimarySideBarFromSearchParams = (searchParams: any): boolean => {
    return stringToBoolean(getRawShowPrimarySideBarFromSearchParams(searchParams));
};

export const setShowPrimarySideBarOnSearchParams = (searchParams: any, setSearchParams: any, status: boolean) => {
    searchParams.set(SHOW_PRIMARY_MENU, status);
    setSearchParams(searchParams);
};

export const getShowSecondarySideBarFromSearchParams = (searchParams: any): boolean => {
    return stringToBoolean(getRawShowSecondarySideBarFromSearchParams(searchParams));
};

export const setShowSecondarySideBarOnSearchParams = (searchParams: any, setSearchParams: any, status: boolean) => {
    searchParams.set(SHOW_SECONDARY_SIDEBAR, status);
    setSearchParams(searchParams);
};

export const convertSearchParamsToQueryString = (searchParams: any) => {
    return "?" + searchParams.toString();
};
